import { render, staticRenderFns } from "./partitionManage.vue?vue&type=template&id=84e01a16&scoped=true&"
import script from "./partitionManage.vue?vue&type=script&lang=js&"
export * from "./partitionManage.vue?vue&type=script&lang=js&"
import style0 from "./partitionManage.vue?vue&type=style&index=0&id=84e01a16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e01a16",
  null
  
)

export default component.exports